import { Checkbox } from '../Checkbox/Checkbox';
import './checkForm.css';

export const CheckForm = ({ children, onChange, checked = false }) => {
    return (
        <div className="check-form">
            <Checkbox checked={checked} onChange={onChange} />
            <p className="body4">{children}</p>
        </div>
    );
};
